<template>
  <label
    for="file-activity"
    class="border border-slate-300 flex flex-col gap-2 items-center justify-center h-28 my-2 rounded-md bg-white"
    v-if="!fileActivity && materials?.length === 0"
  >
    <v-icon name="md-uploadfile" :scale="2" class="text-h-primary-500" />
    <h5 class="text-base text-h-primary-500">
      {{ "Selecionar arquivo para enviar" }}
    </h5>
    <input
      type="file"
      id="file-activity"
      class="hidden"
      multiple
      @change="selectFile"
    />
  </label>
  <div v-else>
    <div
      class="border h-40 p-4 flex flex-col gap-2 justify-center my-2 rudend-md bg-white min-w-[300px]"
    >
      <span class="flex flex-row items-start justify-between">
        <h5 class="text-sm font-normal text-h-neutral-500">
          {{ "Arquivo selecionado:" }}
        </h5>

        <label for="more-files" class="flex flex-row justify-between">
          <span class="flex flex-row gap-4 items-center px-4"
            ><i class="pi pi-plus" style="font-size: 0.7rem" />
            <p>{{ "Arquivo" }}</p>
          </span>

          <input
            type="file"
            id="more-files"
            class="hidden"
            multiple
            @change="addMoreFiles"
          />
        </label>
      </span>

      <div class="overflow-auto min-h-96 flex flex-col gap-2">
        <div
          class="flex flex-row gap-3 bg-h-primary-50 p-4 rounded-md min-w-[270px]"
          v-for="(file, index) in fileActivity"
          :key="index"
        >
          <v-icon name="io-image-sharp" class="text-h-primary-500" />
          <p class="flex-1 text-h-primary-500 text-sm">{{ file?.name }}</p>
          <v-icon
            name="md-close"
            class="text-h-primary-500 cursor-pointer"
            @click="unselectFile(index)"
          />
        </div>
        <div
          v-for="material in materials"
          class="flex flex-row gap-3 bg-h-primary-50 p-4 rounded-md min-w-[270px]"
          :key="material.id"
        >
          <v-icon name="io-image-sharp" class="text-h-primary-500" />
          <p class="flex-1 text-h-primary-500 text-sm">
            {{ material?.name + "." + material?.mimetype }}
          </p>
          <v-icon
            name="md-close"
            class="text-h-primary-500 cursor-pointer"
            @click="unselectMaterial(material?.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      fileActivity: null as File[] | null,
    };
  },
  props: ["materials"],
  emits: ["file-selected", "update:materials", "dismissed-material"],
  methods: {
    selectFile(event: any) {
      if (event.target.files && event.target.files.length > 0) {
        this.fileActivity = Array.from(event.target.files);
      }
    },
    addMoreFiles(event: any) {
      if (event.target.files && event.target.files.length > 0) {
        this.fileActivity = this.fileActivity
          ? this.fileActivity.concat(Array.from(event.target.files))
          : Array.from(event.target.files);
      }
    },
    unselectFile(index: number) {
      if (!this.fileActivity) return;

      this.fileActivity.splice(index, 1);
      if (this.fileActivity.length === 0) {
        this.fileActivity = null;
      }
    },
    unselectMaterial(id: string) {
      if (!id) return;
      const updatedMaterials = this.materials.filter((m) => m.id !== id);
      this.$emit("update:materials", updatedMaterials);
      this.$emit("dismissed-material", id);
    },
  },
  watch: {
    fileActivity(newValue) {
      if (newValue && newValue.length > 0) {
        this.$emit("file-selected", newValue);
      } else {
        this.$emit("file-selected", null);
      }
    },
  },
});
</script>
